/** Query parameter names used to pass IDs between sites. */
export const URL_PARAM_DEVICE_ID = 'd_id';
export const URL_PARAM_SESSION_ID = 's_id';
/**
 * Query parameter name used to inform the target website that user behaviour should not be tracked.
 * Helpful when some web content needs to be embedded into an app respecting the app user preferences.
 */
export const URL_PARAM_OPT_OUT_REQUEST = 'optOutAnalytics';

export const COOKIES_DEVICE_IDS = '__analytics_dids';
export const COOKIES_TTL_DAYS = 300;

export const USER_PROP_COMPONENT_NAME = 'ComponentName';
export const USER_PROP_ANALYTICS_CLIENT_VERSION = 'AnalyticsClientVersion';
